import type {
  MsRecommendationProcessedResponse,
  ProcessedRecommendationItem,
} from '../../interfaces/msRecommendation';

export const mapTopSellRecommendations = (
  topSellRecommendationConfig: MsRecommendationProcessedResponse | undefined,
  playlistRecoEngine: object,
): ProcessedRecommendationItem[] | undefined =>
  topSellRecommendationConfig?.filter(
    (reco: ProcessedRecommendationItem) =>
      Object.values(playlistRecoEngine).includes(reco.engineName as string) &&
      !!reco.modelIds?.length,
  );
